import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import InvoiceLinesFiltersSlidingPanel from './InvoiceLinesFiltersSlidingPanel';
import {
  applyFilters,
  expandInvoiceLineFilter,
  clearInvoiceLineFilter,
  restoreInvoiceLineFilters,
  clearAllInvoiceLineFilters,
  setFilterValue
} from 'redux/invoiceLinesFilters/InvoiceLinesFiltersActions';

const mapStateToProps = ({ invoiceLinesFilters }) => ({
  tempFilters: invoiceLinesFilters.tempFilters
});

const mapDispatchToProps = dispatch => ({
  invoiceLinesFiltersActions: bindActionCreators(
    {
      applyFilters,
      expandInvoiceLineFilter,
      clearInvoiceLineFilter,
      restoreInvoiceLineFilters,
      clearAllInvoiceLineFilters,
      setFilterValue
    },
    dispatch
  )
});

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceLinesFiltersSlidingPanel);



// WEBPACK FOOTER //
// ./src/components/viewTransactions/viewTransactionsGrid/c/invoiceLinesSlidingPanel/invoiceLinesGrid/c/invoiceLinesFilters/InvoiceLinesFiltersSlidingPanelConnector.js